import { render } from "./SettingTableRow.vue?vue&type=template&id=8567112c&scoped=true&ts=true"
import script from "./SettingTableRow.vue?vue&type=script&lang=ts"
export * from "./SettingTableRow.vue?vue&type=script&lang=ts"

import "./SettingTableRow.vue?vue&type=style&index=0&id=8567112c&lang=scss&scoped=true"
import "./SettingTableRow.vue?vue&type=style&index=1&id=8567112c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8567112c"]])

export default __exports__